import { useScreeningDescriptionText } from '../ScreeningShared'
import { useScreeningContinue } from '../useScreeningContinue'
import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useSelectFormattedScreeningHandledDate } from '../../../../state/selectors'
import { ScreeningType } from '@estercare/ester-shared'
import { useTranslation } from 'react-i18next'
import { useGetUserHealthPlanOutcomesQuery } from '../../../../api/ester-b2b-api/private/healthPlan/healthPlanQueries'
import { Outcomes } from '../../../healthPlan/Outcomes'

export const ScreeningFollowUpContinue = () => {
  const parentScreeningDate = useSelectFormattedScreeningHandledDate()
  const { t } = useTranslation()
  const { data: outcomesData } = useGetUserHealthPlanOutcomesQuery()

  const screeningDescription = useScreeningDescriptionText(ScreeningType.FOLLOW_UP, parentScreeningDate || '')
  const { onContinue, optInFields, isButtonDisabled, errorMsg } = useScreeningContinue('follow_up_continue')
  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.followUpContinuePage')}
      screeningTitle={t('employee.screening.followUpTitle')}
      screeningDescription={screeningDescription}
      screeningAdditionalChildren={optInFields}
      fullWidthChildren={
        outcomesData?.outcomes?.length ? (
          <Outcomes
            outcomes={outcomesData.outcomes}
            title={t('employee.screening.outcomesTitle', { date: parentScreeningDate })}
            description={t('employee.screening.outcomesDescription')}
          />
        ) : undefined
      }
      buttonText={t('employee.screening.followUpContinueButton')}
      onButtonClick={onContinue}
      isButtonDisabled={isButtonDisabled}
      errorMsg={errorMsg}
    />
  )
}
